import { parseMobileNumber } from "@/utils/formatMobileNumber";
import { TProfile } from "./types";
import { TALIBON_ADDRESS_INITIAL_VALUES } from "@/features/constants";

export const transformProfile = (raw: any): TProfile => ({
  display_name: raw?.display_name,
  first_name: raw?.first_name,
  middle_name: raw?.middle_name,
  last_name: raw?.last_name,
  extension_name: raw?.extension_name,
  email: raw?.email,
  mobile_number: parseMobileNumber(raw?.mobile_number),
  gender: raw?.gender,
  civil_status: raw?.civil_status,
  id_type: raw?.id_type,
  telephone_number: raw?.telephone_number,
  photo: raw?.photo,
  birth_date: raw?.birth_date,
  place_of_birth_region_code: raw?.place_of_birth_region_code,
  place_of_birth_region_name: raw?.place_of_birth_region_name,
  place_of_birth_province_code: raw?.place_of_birth_province_code,
  place_of_birth_province_name: raw?.place_of_birth_province_name,
  place_of_birth_municipality_code: raw?.place_of_birth_municipality_code,
  place_of_birth_municipality_name: raw?.place_of_birth_municipality_name,
  place_of_birth_barangay_code: raw?.place_of_birth_barangay_code,
  place_of_birth_barangay_name: raw?.place_of_birth_barangay_name,
  region_code: raw?.region_code ?? TALIBON_ADDRESS_INITIAL_VALUES.regionCode,
  region_name: raw?.region_name,
  province_code: raw?.province_code ?? TALIBON_ADDRESS_INITIAL_VALUES.provinceCode,
  province_name: raw?.province_name,
  municipality_code: raw?.municipality_code ?? TALIBON_ADDRESS_INITIAL_VALUES.municipalityCode,
  municipality_name: raw?.municipality_name,
  barangay_code: raw?.barangay_code ?? "",
  barangay_name: raw?.barangay_name,
  is_resident: Boolean(raw?.is_resident),
  mother_maiden_first_name: raw?.mother_maiden_first_name,
  mother_maiden_middle_name: raw?.mother_maiden_middle_name,
  mother_maiden_last_name: raw?.mother_maiden_last_name,
  mother_maiden_suffix_name: raw?.mother_maiden_suffix_name,
  father_first_name: raw?.father_first_name,
  father_middle_name: raw?.father_middle_name,
  father_last_name: raw?.father_last_name,
  father_suffix_name: raw?.father_suffix_name,
  height: raw?.height,
  weight: raw?.weight,
  complexion: raw?.complexion,
  citizenship_code: raw?.citizenship_code || "PHL",
  citizenship_name: raw?.citizenship_name || "Philippines",
  highest_educational_attainment: raw?.highest_educational_attainment,
  institution_code: raw?.institution_code,
  institution_name: raw?.institution_name,
  driver_license_number: raw?.driver_license_number,
  tin_number: raw?.tin_number,
  philhealth_id_number: raw?.philhealth_id_number,
  gsis_id_number: raw?.gsis_id_number,
  pagibig_id_number: raw?.pagibig_id_number,
  sss_id_number: raw?.sss_id_number,
  address: raw?.street,
  street: raw?.street,

  is_onboarded: Boolean(raw?.last_name && raw?.first_name && raw?.gender && raw?.civil_status),

  google2fa_enable: raw?.google2fa_enable,
  google2fa_secret: raw?.google2fa_secret,

  mfa_type: raw?.mfa_type,

  email2fa_enable: raw?.email2fa_enable,
  otp2fa_enable: raw?.otp2fa_enable
});
